import { TYPES } from "./onboard.type";

const initState = {
  isOnboard: false,
};

const onboardReducer = (state = initState, action) => {
  switch (action.type) {
    case TYPES.SET_ONBOARD_HAS:
      return {
        ...state,
        isOnboard: action.payload,
      };
    default:
      return state;
  }
};
export default onboardReducer;
